// extracted by mini-css-extract-plugin
export default {"error":"NewUserError_error__2IESB","success":"NewUserError_success__5k6o2","link":"NewUserError_link__fVnLx","breathing":"NewUserError_breathing__LKi8y"};